import { Link } from 'react-router-dom'; // Import Link

import ctaThreeBg from '../../assets/images/backgrounds/cta-three-bg.jpg';
import ctaTwoShape from '../../assets/images/shapes/cta-three-left-shape-1.png';

// CTA data (if needed for dynamic content)
const ctaData = {
  contactNumber1: '01959701730',
  contactNumber2: '(603) 555-0123',
};

export default function CTAThree() {
  return (
    <>
      {/* CTA Three Start */}
      <section className="cta-three">
        <div className="container">
          <div className="cta-three__inner">
            <div
              className="cta-three__bg"
              style={{ backgroundImage: `url(${ctaThreeBg})` }}
            ></div>
            <div className="cta-three__left">
              <h3 className="cta-three__title">Need any help? Please<br /> contact us</h3>
              <div className="cta-three__contact-number">
                <div className="cta-three__left-shape float-bob-x">
                  <img src={ctaTwoShape} alt="" />
                </div>
                <Link to={`tel:${ctaData.contactNumber1}`}>{ctaData.contactNumber1}</Link>
                <Link to={`tel:${ctaData.contactNumber2}`}>{ctaData.contactNumber2}</Link>
              </div>
            </div>
            <div className="cta-three__right">
              <div className="cta-three__icon-and-btn">
                <div className="cta-three__icon-box">
                  <div className="cta-three__icon-shape"></div>
                  <div className="cta-three__icon">
                    <span className="icon-call"></span>
                  </div>
                </div>
                <div className="cta-three__btn-box">
                  <Link to="/contact" className="cta-three__btn thm-btn-two">
                    Contact Us<span className="icon-dubble-arrow-right"></span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Three End */}
    </>
  );
}
